<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div v-html="sample.desc"></div>
      </b-col>
      <div class="w-100"></div>
      <b-col class="mt-3">
        {{sample.contact}}
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="4" sm="3">
        <strong>Tel.:</strong>
      </b-col>
      <b-col cols="8" sm="9">
        <a class="kub-desc-contact-light" :href="'tel:' + contact.phoneTo.content">{{ contact.phone.content }}</a>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="4" sm="3">
        <strong>E-Mail:</strong>
      </b-col>
      <b-col cols="8" sm="9">
        <a class="kub-desc-contact-light" :href="'mailto:' + contact.mail.content">{{ contact.mail.content }}</a>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DataSample from './../../data/general/sample'
import DataContact from './../../data/general/contact'

export default {
  data () {
    return {
      sample: DataSample.sample,
      contact: DataContact.contact
    }
  }
}
</script>

<style>
</style>
